import { useMemo } from 'react';
import { usePage } from '@inertiajs/react';

import type { PageEditorSharedData } from '@/types/page';
import { getMetadataFieldConfig } from './helpers';
import type { MetadataDialogKind } from './types';

export function useMetadataFieldConfig(kind: MetadataDialogKind) {
  const { contentModelMetadataConfig } = usePage<PageEditorSharedData>().props;

  return useMemo(
    () => getMetadataFieldConfig(kind, contentModelMetadataConfig),
    [kind, contentModelMetadataConfig],
  );
}
